import { createSlice } from "@reduxjs/toolkit";
import { userQueryPost } from "../../thunks/common-thunks/commonThunk";
import { message } from "antd";
const initialState = {
  isLoading: false,
  error: null,
  addStatus: "idle",
  addStatusMsg: null,
  updateAdvResult: null,
  isLeadSuccess: false,
};
export const billboardEnquirySlice = createSlice({
  name: "billboardEnquiry",
  initialState,
  reducers: {
    RESET_ADV: (state) => {
      state.addStatus = null;
      state.updateAdvResult = null;
    },
    CLEAR_LEAD_SUCCESS: (state) => {
      state.isLeadSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(userQueryPost.pending, (state) => {
        state.isLoading = true;
        state.addStatus = "loading";
        state.error = null;
      })
      .addCase(userQueryPost.fulfilled, (state, action) => {
        state.isLoading = false;
        state.addStatus = "success";
        state.updateSubmitAdd = action.payload;
        state.updateAdvResult = action.payload.message;
        state.isLeadSuccess = true;
      })
      .addCase(userQueryPost.rejected, (state, action) => {
        state.isLoading = false;
        state.addStatus = "failed";
        state.error = action.error?.message || "Something went wrong";
        message.error("Something went wrong!");
      });
  },
});
export const { RESET_ADV, CLEAR_LEAD_SUCCESS } = billboardEnquirySlice.actions;
export default billboardEnquirySlice.reducer;
